import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import SercomGrid from '../../components/Grid';
import { DataManager } from '@syncfusion/ej2-data';
import { GridComponent, SortSettingsModel } from '@syncfusion/ej2-react-grids';
import SercomEnums from '../../support/sercom-enums';
import { useTranslation } from 'react-i18next';
import AdminService from '../../services/admin-service';
import SercomConstants from '../../support/sercom-constants';

const NotificationStatisticsPage = () => {
  const [dataSource, setDataSource] = useState<DataManager | undefined>(undefined);
  const companyGridRef = useRef<GridComponent | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    async function init() {
      const dataManager = await AdminService.getNotificationStatisticsDatasource();
      setDataSource(dataManager);
    }
    init();
  }, []);

  const columns = [
    { field: 'Id', type: 'string', headerText: 'Id', isPrimaryKey: true, visible: false, showInColumnChooser: false },
    { field: 'CompanyName', type: 'string', headerText: t('CompanyName'), visible: true, allowSearch: true },
    {
      field: 'ClientReminderEmail',
      type: 'number',
      headerText: t('ClientReminderEmail'),
      visible: true,
    },
    {
      field: 'ClientReminderSms',
      type: 'number',
      headerText: t('ClientReminderSms'),
      visible: true,
    },
    {
      field: 'ClientOnTheWayEmail',
      type: 'number',
      headerText: t('ClientOnTheWayEmail'),
      visible: true,
    },
    {
      field: 'ClientOnTheWaySms',
      type: 'number',
      headerText: t('ClientOnTheWaySms'),
      visible: true,
    },
    {
      field: 'DailyJobEmail',
      type: 'number',
      headerText: t('DailyJobEmail'),
      visible: true,
    },
    {
      field: 'DailyJobSms',
      type: 'number',
      headerText: t('DailyJobSms'),
      visible: true,
    },
    {
      field: 'DailyJobMobile',
      type: 'number',
      headerText: t('DailyJobMobile'),
      visible: true,
    },
    {
      field: 'AssignedJobEmail',
      type: 'number',
      headerText: t('AssignedJobEmail'),
      visible: true,
    },
    {
      field: 'AssignedJobSms',
      type: 'number',
      headerText: t('AssignedJobSms'),
      visible: true,
    },
    {
      field: 'AssignedJobMobile',
      type: 'number',
      headerText: t('AssignedJobMobile'),
      visible: true,
    },
    {
      field: 'RecurringJobOccurrence',
      type: 'number',
      headerText: t('RecurringJobOccurrences'),
      visible: true,
    },
    {
      field: 'Date',
      type: 'date',
      headerText: t('Date'),
      format: { type: 'date', format: SercomConstants.DateFormat.SYNCFUSION_ISO },
      visible: true,
    },
  ];
  const sortSettings: SortSettingsModel = { columns: [{ field: 'Date', direction: 'Descending' }] };

  return dataSource ? (
    dataSource && (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <SercomGrid
          gridRef={companyGridRef}
          dataSource={dataSource}
          columns={columns}
          gridCustomizationType={SercomEnums.GridCustomizationType.AdminNotificationStatistic}
          // recordClick={onRecordClick}
          sortSettings={sortSettings}
        />
      </Box>
    )
  ) : (
    <div></div>
  );
};

export default NotificationStatisticsPage;
